import { useState } from "react";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import Loader from "../Loader";
import { LessonsExploreFilterBar } from "./LessonsExploreFilterBar";
import { LessonsExploreList } from "./LessonsExploreList";
import type {
	ExploreLesson,
	LessonStatusFilter,
	LessonViewMode,
} from "./types";

type Props = {
	title: string;
	lessons: ExploreLesson[];
	totalLessons: number;
	statusFilter: LessonStatusFilter;
	onChangeStatusFilter: (filter: LessonStatusFilter) => void;
	onLessonPress: (lesson: ExploreLesson) => void;
	onClearFilters: () => void;
	isLoading?: boolean;
};

export const LessonsExploreScreen = ({
	title,
	lessons,
	totalLessons,
	statusFilter,
	onChangeStatusFilter,
	onLessonPress,
	onClearFilters,
	isLoading = false,
}: Props) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();
	const [viewMode, setViewMode] = useState<LessonViewMode>("list");

	if (isLoading) {
		return <Loader />;
	}

	return (
		<Box flex={1}>
			<Box
				alignSelf="center"
				width="100%"
				maxWidth={theme.breakpoints?.sm}
				paddingTop={isMobile ? 8 : 24}
				paddingBottom={isMobile ? 8 : 16}
				paddingHorizontal={isMobile ? 16 : 0}
			>
				<LessonsExploreFilterBar
					title={title}
					statusFilter={statusFilter}
					onChangeStatusFilter={onChangeStatusFilter}
					viewMode={viewMode}
					onChangeViewMode={setViewMode}
					showViewToggle={!isMobile}
					isMobile={isMobile}
				/>
			</Box>
			<Box flex={1} width="100%">
				<LessonsExploreList
					lessons={lessons}
					viewMode={viewMode}
					isMobile={isMobile}
					statusFilter={statusFilter}
					totalLessons={totalLessons}
					onLessonPress={onLessonPress}
					onClearFilters={onClearFilters}
					contentContainerStyle={{
						paddingBottom: 200,
						width: "100%",
						maxWidth: theme.breakpoints?.sm,
						alignSelf: "center",
					}}
				/>
			</Box>
		</Box>
	);
};
